import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

interface MyCafeteriaSignatureBlockProps {
  statement: string;
}

export const MyCafeteriaSignatureBlock: React.FC<
  MyCafeteriaSignatureBlockProps
> = ({ statement }) => {
  const { t } = useTranslation();

  return (
    <Box id="lower-component" sx={{ display: "none", displayPrint: "block" }}>
      <Box
        id="signs"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        padding="0px 80px"
        marginBottom={statement === "vbk" ? "108px" : "0px"}
      >
        <Box display="flex" flexDirection="row">
          <Typography
            variant="body2"
            style={{
              fontWeight: "400",
            }}
          >
            {t("MY_CAFETERIA_DATE_OF_SIGN")}
          </Typography>
          <Box width="6px"></Box>
          <Box
            marginTop="16px"
            height="1px"
            width="147.67px"
            style={{
              backgroundColor: "#4d4d4d",
            }}
          />
        </Box>
        <Box display="flex" flexDirection="row" paddingTop="16px">
          <Box width="156px" borderTop="1px solid #4d4d4d" textAlign="center">
            <Typography
              variant="body2"
              style={{
                fontWeight: "400",
              }}
            >
              {t("MY_CAFETERIA_EMPLOYEE_SIGN")}
            </Typography>
          </Box>
          <Box width="24px" />
          <Box width="156px" borderTop="1px solid #4d4d4d" textAlign="center">
            <Typography
              variant="body2"
              style={{
                fontWeight: "400",
              }}
            >
              {t("MY_CAFETERIA_FOR_THE_EMPLOYER")}
            </Typography>
          </Box>
        </Box>
      </Box>
      {statement === "szep" && (
        <Box paddingTop="50px" paddingBottom="40px">
          <Typography
            variant="body1"
            style={{
              paddingLeft: "67px",
              paddingRight: "67px",
            }}
          >
            {t("MY_CAFETERIA_STATEINDUP")}
          </Typography>
        </Box>
      )}{" "}
    </Box>
  );
};

export default MyCafeteriaSignatureBlock;
